import { render, staticRenderFns } from "./CPTemp2.vue?vue&type=template&id=59b21e70&scoped=true&"
import script from "./CPTemp2.vue?vue&type=script&lang=js&"
export * from "./CPTemp2.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp2.vue?vue&type=style&index=0&id=59b21e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b21e70",
  null
  
)

export default component.exports